import _ from "lodash";

import { ADMIN_MENU } from "../../../../constants/permissions";

export const getUnitPropertie = (fieldProperties, constraintId) => {
  let model =
    fieldProperties &&
    _.find(fieldProperties.properties, function (a) {
      return a.id === constraintId;
    });
  model = model && model.value;
  return model;
};

export const getfieldPropertie = (fieldProperties, constraintId) => {
  const obj =
    fieldProperties &&
    _.find(fieldProperties.properties, function (a) {
      return a.id === constraintId;
    });
  return obj;
};

export const getPropertie = (properties, constraintId) => {
  const model =
    properties &&
    _.find(properties, function (a) {
      return a.id === constraintId;
    });
  return model;
};

export const havePermissionByPropertie = (propertie, userPermission, user) => {
  let haveAdminPermission;
  let haveGroupPermission;
  let haveUserPermission;

  userPermission &&
    userPermission.map((item) => {
      ADMIN_MENU.includes(item) && (haveAdminPermission = true);
      return haveAdminPermission;
    });

  propertie &&
    propertie.map((member) => {
      userPermission.includes(member.id) && (haveGroupPermission = true);
      user.id === member.id && (haveUserPermission = true);
      return haveUserPermission;
    });

  const permission =
    haveUserPermission || haveGroupPermission || haveAdminPermission;

  return !!permission;
};
